import { z } from "zod";

const assetResponseSchema = z.object({ id: z.string(), url: z.string() });

export async function uploadAsset(
    blob: Blob,
    filename: string,
): Promise<{ id: string; url: string }> {
    const formData = new FormData();
    formData.append("file", new File([blob], filename, { type: "image/png" }));

    const response = await fetch(
        `${import.meta.env.VITE_BACKEND_REST_ENDPOINT}/rest/assets`,
        {
            method: "POST",
            headers: {
                Authorization: `ApiKey ${import.meta.env.VITE_BACKEND_API_KEY}`,
            },
            body: formData,
        },
    );

    if (!response.ok) {
        throw new Error(`Asset upload failed: ${response.status}`);
    }

    const data = assetResponseSchema.parse(await response.json());
    return { id: data.id, url: data.url };
}
